import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioService, PageBusquedaObject, GralUsrDto, GralUsrRoleDto, GralRoleDto, GralUsrPictureDto } from '../usuario.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';

import { Location } from '@angular/common';
@Component({
  selector: 'app-formulario-usuario',
  templateUrl: './formulario-usuario.component.html',
  styleUrls: ['./formulario-usuario.component.css'],
  preserveWhitespaces: true
})
export class FormularioUsuarioComponent implements OnInit {
  user: GralUsrDto = new GralUsrDto();
  rotate: any;
  cargado: boolean;
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  perfil: boolean;
  roles: GralRoleDto[];
  empresas: any[] = [{suc: []}];
  index_emp = 0;
  emps: any[] = [];
  sucs: any[] = [];
  id_param: number;
  generarPassword = false;
  errors: String[];
  constructor(public location: Location,private loginService: LoginService, private service: UsuarioService,
    private activatedRoute: ActivatedRoute, private router: Router) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 5;
    this.busqueda.pageNumber = 0;
    // this.empresas = this.loginService.empresas;
  }
  validarSucursalesSeleccionadas(sucursales: any[]) {
    for (let x = 0 ; x < sucursales.length; x++) {
      if (sucursales[x].seleccionado == true) {
        return true;
      }
    }
    return false;
  }
  asignarIndiceEmpresa(index_emp: number) {
    this.index_emp = index_emp;
  }
  cargarEmpresas() {
    this.service.getAllEmp().subscribe(
      response => {
        this.empresas = response.contenido;
        for (let x = 0; x < this.empresas.length; x++) {
          for (let y = 0; y < this.empresas[x].suc.length; y++) {
            for (let x1 = 0; x1 < this.user.empresas.length; x1++) {
              for (let y1 = 0; y1 < this.user.empresas[x1].suc.length; y1++) {
                if (this.empresas[x].id == this.user.empresas[x1].id) {
                  this.empresas[x].seleccionado = true;
                }
                if (this.empresas[x].suc[y].id == this.user.empresas[x1].suc[y1].id) {
                  this.empresas[x].suc[y].seleccionado = true;
                }
              }
            }
          }
        }
      }, err => {
        console.log(err);
      }
    );
  }

  ngOnInit(): void {
    this.cargarFormulario()
  }
  async cargarFormulario() {
    this.cargado = true;
    this.cargarEmpresas();
    this.user.gralUsrPictureDto = new GralUsrPictureDto();
    await this.cargarRoles();
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.getUsuarioUsingGET(this.id_param).subscribe(response => {
          console.log(response.contenido);
          this.user = response.contenido;
          if (this.user.id === this.loginService.usuario.id) {
            let ruta = this.router.url;
            console.log(ruta);
            if (ruta.includes('perfil')) {
              this.perfil = true;
            }
          }
          if (!this.user.empleado) {
          }
          this.cargarEmpresas();
          this.cerrarMensajeCarga();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        }, () => {
        });
      } else {
      }
    });
  }
  seleccionarTodo(campo: String) {
    switch (campo) {
      case 'ver':
      for (let x = 0 ; x < this.user.gralUsrRoleDto.length ; x++) {
        if (this.user.gralUsrRoleDto[x].ctb === true) {
          this.user.gralUsrRoleDto[x].gral_role_read = true;
        }
      }
        break;
      case 'Crear':
      for (let x = 0 ; x < this.user.gralUsrRoleDto.length ; x++) {
        if (this.user.gralUsrRoleDto[x].ctb === true) {
          this.user.gralUsrRoleDto[x].gral_role_write = true;
        }
      }
        break;
      case 'Actualizar':
      for (let x = 0 ; x < this.user.gralUsrRoleDto.length ; x++) {
        if (this.user.gralUsrRoleDto[x].ctb === true) {
          this.user.gralUsrRoleDto[x].gral_role_update = true;
        }
      }
        break;
      case 'Eliminar':
      for (let x = 0 ; x < this.user.gralUsrRoleDto.length ; x++) {
        if (this.user.gralUsrRoleDto[x].ctb === true) {
          this.user.gralUsrRoleDto[x].gral_role_delete = true;
        }
      }
        break;
    }
  }

  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
  asignarEmpSuc(x: any, y: any) {
  }
  buscarRole(i: number): any {
    for (var x = 0; x < this.roles.length; x++) {
      if (this.user.gralUsrRoleDto[i].gral_role === this.roles[x].id) {
        return this.roles[x].name;
      }
    }
  }
  crearUsuario() {
    for (let x = 0; x < this.empresas.length; x++) {
      for (let y = 0; y < this.empresas[x].suc.length; y++) {
        if (this.empresas[x].suc[y].seleccionado == true) {
          this.empresas[x].seleccionado = true;
          break;
        }
      }
    }
    this.user.empresas = this.empresas;
    this.service.postUserUsingPOST(this.user, this.loginService.usuario.id).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/usuario']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  actualizarUsuario() {
    for (let x = 0; x < this.empresas.length; x++) {
      for (let y = 0; y < this.empresas[x].suc.length; y++) {
        if (this.empresas[x].suc[y].seleccionado == true) {
          this.empresas[x].seleccionado = true;
          break;
        }
      }
    }
    this.user.empresas = this.empresas;
    this.service.putUserUsingPUT(this.user, this.loginService.usuario.id).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/usuario']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  async cargarRoles(): Promise<void> {
    return this.service.listRoleUsingGET().toPromise().then(response => {
      this.roles = response;
      this.user.gralUsrRoleDto = [];
      for (let x = 0; x < this.roles.length; x++) {
        const roleUser = new GralUsrRoleDto();
        roleUser.gral_role = this.roles[x].id;
        roleUser.gral_role_write = false;
        roleUser.gral_role_read = false;
        roleUser.gral_role_delete = false;
        roleUser.gral_role_update = false;
        roleUser.ctb = this.roles[x].ctb;
        this.user.gralUsrRoleDto.push(roleUser);
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
    });
  }
  handleUpload(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.user.gralUsrPictureDto.picture = reader.result.toString();
    };
  }
  wait(ms) {
   var start = new Date().getTime();
   var end = start;
   while(end < start + ms) {
     end = new Date().getTime();
  }
}
  seleccionarTodosRoles(indice: number) {
    if (this.buscarRole(indice) === 'ADMINISTRADOR') {
      for (let x = 0; x < this.user.gralUsrRoleDto.length ; x++) {
         this.user.gralUsrRoleDto[x].gral_role_read = this.user.gralUsrRoleDto[indice].gral_role_read;
         this.user.gralUsrRoleDto[x].gral_role_delete = this.user.gralUsrRoleDto[indice].gral_role_delete;
         this.user.gralUsrRoleDto[x].gral_role_update = this.user.gralUsrRoleDto[indice].gral_role_update;
         this.user.gralUsrRoleDto[x].gral_role_write = this.user.gralUsrRoleDto[indice].gral_role_write;

      }
    }

  }
  cerrarFromulario(){
    this.location.back();
  }
}
